import {useEffect, useState} from 'react';
import {useGeoSearch} from "react-instantsearch";


// Method 1: Extract from search results using _rankingInfo
const useDetectedLocationFromResults = () => {
    const {items} = useGeoSearch();
    const [detectedLocation, setDetectedLocation] = useState<{
        lat: number,
        lng: number,
        source: string
    }>();

    useEffect(() => {
        if (items.length > 0 && items[0]._rankingInfo?.matchedGeoLocation) {
            const location = items[0]._rankingInfo.matchedGeoLocation;
            setDetectedLocation({
                lat: location.lat,
                lng: location.lng,
                source: 'algolia_ranking'
            });
        }
    }, [items]);

    return detectedLocation;
};


export default useDetectedLocationFromResults;